import React from 'react';
import { trackFbEvent } from '../utils/fbpixel';
const tomos = [{
  icon: '📘',
  title: 'TOMO 1 · La capa Protectora, el Biofilm',
  desc: 'Por qué fallaste antes y qué cambia ahora',
  value: 'Valor $12.000'
}, {
  icon: '📗',
  title: 'TOMO 2 · 72 Horas Para bajar tu Dolor',
  desc: 'Alivio inmediato sin químicos agresivos',
  value: 'Valor $12.000'
}, {
  icon: '📙',
  title: 'TOMO 3 · Nutrición Anti-Hongos',
  desc: 'Qué comprar en el supermercado',
  value: 'Valor $10.000'
}, {
  icon: '📕',
  title: 'TOMO 4 · El Eje Intestino-Vagina',
  desc: 'Cortar la fuente de re-infección de raíz',
  value: 'Valor $12.000'
}, {
  icon: '📓',
  title: 'TOMO 5 · Suplementación Estratégica',
  desc: 'Los 5 antifúngicos naturales más potentes',
  value: 'Valor $10.000'
}, {
  icon: '📔',
  title: 'TOMO 6 · Blindaje Para extinguir el Hongo',
  desc: 'Que no vuelva nunca más',
  value: 'Valor $10.000'
}];
const bonuses = [{
  icon: '🌙',
  title: 'BONUS 1 · Guía de Rescate Nocturno',
  desc: 'Alivio en 15 min cuando el ardor no te deja dormir',
  value: 'Valor $8.000'
}, {
  icon: '🍳',
  title: 'BONUS 2 · Recetario Sin Dulce',
  desc: '20 recetas ricas que matan al hongo con ingredientes de tu super',
  value: 'Valor $8.000'
}, {
  icon: '🧴',
  title: 'BONUS 3 · Revisión de Productos de Baño',
  desc: 'Los productos que destruyen tu pH todos los días sin que lo sepas',
  value: 'Valor $7.000'
}];
export function ProductSection() {
  return <section className="w-full bg-[#F8F5FC] px-6 py-16" data-id="element-229">
      <div className="max-w-2xl mx-auto" data-id="element-230">
        <h2 className="text-[28px] font-bold text-brand-text text-center mb-2 leading-tight" data-id="element-231">
          TODO LO QUE RECIBÍS HOY
        </h2>
        <p className="text-brand-muted text-center text-[16px] mb-8" data-id="element-232">
          No es un libro. Es un sistema de 9 piezas.
        </p>

        <a href="#compra" onClick={() => trackFbEvent('InitiateCheckout', {
        content_name: 'Product CTA',
        value: 19990,
        currency: 'ARS'
      })} className="w-full block bg-brand-magenta hover:brightness-110 text-white font-bold text-[16px] rounded-xl py-4 text-center transition-all shadow-[0_4px_24px_rgba(212,0,110,0.25)] mb-12" data-id="element-233">
          🔓 QUIERO EL MÉTODO pH-ZERO
        </a>

        <div className="flex flex-col gap-4 mb-12" data-id="element-234">
          {tomos.map((tomo, i) => <div key={i} className="bg-white rounded-[16px] p-5 shadow-[0_4px_24px_rgba(0,0,0,0.08)] border-l-4 border-brand-violet flex flex-col sm:flex-row sm:items-center gap-4" data-id="element-235">
              <div className="flex-1 flex items-start gap-3" data-id="element-236">
                <span className="text-2xl flex-shrink-0" data-id="element-237">{tomo.icon}</span>
                <div data-id="element-238">
                  <p className="text-brand-text font-bold text-[15px] leading-tight mb-1" data-id="element-239">
                    {tomo.title}
                  </p>
                  <p className="text-brand-muted text-[13px] leading-snug" data-id="element-240">
                    {tomo.desc}
                  </p>
                </div>
              </div>
              <div className="inline-flex items-center px-3 py-1 bg-brand-violet/10 text-brand-violet text-[12px] font-bold rounded-full whitespace-nowrap self-start sm:self-auto" data-id="element-241">
                {tomo.value}
              </div>
            </div>)}
        </div>

        <div className="flex flex-col items-center mb-8" data-id="element-242">
          <div className="w-full h-px bg-brand-gray mb-6" data-id="element-243" />
          <h3 className="text-[20px] font-bold text-brand-text mb-3 text-center" data-id="element-244">
            🎁 MÁS TUS 3 REGALOS EXCLUSIVOS
          </h3>
          <div className="inline-flex items-center px-4 py-1.5 rounded-full bg-green-100 text-green-800 text-sm font-bold" data-id="element-245">
            🎉 ¡GRATIS por el día de hoy!
          </div>
        </div>

        <div className="flex flex-col gap-4" data-id="element-246">
          {bonuses.map((bonus, i) => <div key={i} className="bg-white rounded-[16px] p-5 shadow-[0_4px_24px_rgba(0,0,0,0.08)] border-l-4 border-green-500 flex flex-col sm:flex-row sm:items-center gap-4 relative" data-id="element-247">
              <div className="absolute top-4 right-4 px-2 py-1 bg-green-100 text-green-800 text-[10px] font-bold rounded-full" data-id="element-248">
                GRATIS HOY
              </div>
              <div className="flex-1 flex items-start gap-3 pr-20 sm:pr-0" data-id="element-249">
                <span className="text-2xl flex-shrink-0" data-id="element-250">{bonus.icon}</span>
                <div data-id="element-251">
                  <p className="text-brand-text font-bold text-[15px] leading-tight mb-1" data-id="element-252">
                    {bonus.title}
                  </p>
                  <p className="text-brand-muted text-[13px] leading-snug" data-id="element-253">
                    {bonus.desc}
                  </p>
                </div>
              </div>
              <div className="inline-flex items-center px-3 py-1 bg-brand-gray text-brand-muted text-[12px] font-bold rounded-full whitespace-nowrap self-start sm:self-auto line-through" data-id="element-254">
                {bonus.value}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}